import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryOrderDetailColumn } from '../constants/dictionary-order-detail-columns.constant';
import { Link } from 'react-router-dom';

export const generateOrderDetailColumns = () => {
	return [
		{
			title: dictionaryOrderDetailColumn[Enviroment.LANGUAGE].quotation_id,
			dataIndex: 'short_code',
			key: 'short_code',
			render: (short_code, record) => (
				<Link to={`/quotation/detail/${record?.quotation_id}`}>
					{short_code}
				</Link>
			),
		},
		
		{
			title: dictionaryOrderDetailColumn[Enviroment.LANGUAGE].preorder_id,
			dataIndex: 'tracking_id',
			key: 'tracking_id',
			render: (tracking_id, record) => (
				<Link to={`/preorder/detail/${record?.purchase_id}`}>
					{tracking_id}
				</Link>
			),
		},
		{
			title: dictionaryOrderDetailColumn[Enviroment.LANGUAGE].order_id,
			dataIndex: 'trx_id',
			key: 'trx_id',
		},
		{
			title: dictionaryOrderDetailColumn[Enviroment.LANGUAGE].operation_id,
			dataIndex: 'operation_id',
			key: 'operation_id',
		},
		{
			title: dictionaryOrderDetailColumn[Enviroment.LANGUAGE].date_order,
			dataIndex: 'createdAt',
			key: 'createdAt',
		},
		{
			title: dictionaryOrderDetailColumn[Enviroment.LANGUAGE].schedule_selected,
			dataIndex: 'schedule_selected',
			key: 'schedule_selected',
		},
	];
};
